import { createContext, useContext } from 'react';

const SideNavLayoutContext = createContext(false);

export const SideNavLayoutProvider = SideNavLayoutContext.Provider;

export const useSideNavActive = (): boolean => useContext(SideNavLayoutContext);
